import { render, staticRenderFns } from "./MedicinesAndDrugs.vue?vue&type=template&id=3f443f63&scoped=true"
import script from "./MedicinesAndDrugs.vue?vue&type=script&lang=js"
export * from "./MedicinesAndDrugs.vue?vue&type=script&lang=js"
import style0 from "./MedicinesAndDrugs.vue?vue&type=style&index=0&id=3f443f63&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f443f63",
  null
  
)

export default component.exports